import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentConfigurationComponent } from './component/document-template-administration.component';
import { TemplateFieldDetailsComponent } from './component/template-field-details/template-field-details.component';
import { TemplateDetailsComponent } from './component/template-details/template-details.component';
import { TemplateAreaDetailsComponent } from './component/template-area-details/template-area-details.component';
import { DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';
import { CommonModule } from '@angular/common';
import { TemplatePropertiesComponent } from './component/template-properties/template-properties.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TemplateLookupEditorComponent } from './component/template-lookup-editor/template-lookup-editor.component';
import { TemplateLookupFieldsEditorComponent } from './component/template-lookup-editor/template-lookup-field-editor.component';

import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';

import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatInputModule as MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    TemplateAreaDetailsComponent,
    TemplateDetailsComponent,
    TemplateFieldDetailsComponent,
    DocumentConfigurationComponent,
    TemplatePropertiesComponent,
    TemplateLookupEditorComponent,
    TemplateLookupFieldsEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    MatFormFieldModule,
    DragDropModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule
  ]
})
export class DocumentTemplateAdministrationModule { }
